<template>
  <v-card>
    <v-card-text>
      <v-layout row wrap>
        <v-flex class="text-left">
          <v-toolbar dense>
            <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
              <div>
                <v-btn icon :class="{ 'is-active': isActive.bold() }" @click="commands.bold">
                  <v-icon>fa-bold</v-icon>
                </v-btn>
                <v-btn
                  icon
                  :class="{ 'is-active': isActive.heading({ level: 1 }) }"
                  @click="commands.heading({ level: 1 })"
                >H1</v-btn>
                <v-btn
                  icon
                  :class="{ 'is-active': isActive.heading({ level: 2 }) }"
                  @click="commands.heading({ level: 2 })"
                >H2</v-btn>
                <v-btn
                  icon
                  :class="{ 'is-active': isActive.heading({ level: 3 }) }"
                  @click="commands.heading({ level: 3 })"
                >H3</v-btn>
                <v-btn
                  icon
                  :class="{ 'is-active': isActive.heading({ level: 4 }) }"
                  @click="commands.heading({ level: 4 })"
                >H4</v-btn>
                <v-btn
                  icon
                  :class="{ 'is-active': isActive.heading({ level: 5 }) }"
                  @click="commands.heading({ level: 5 })"
                >H5</v-btn>

                <v-btn
                  icon
                  class="menubar__button"
                  :class="{ 'is-active': isActive.paragraph() }"
                  @click="commands.paragraph"
                >
                  <v-icon>fa-paragraph</v-icon>
                </v-btn>

                <v-btn
                  icon
                  class="menubar__button"
                  :class="{ 'is-active': isActive.italic() }"
                  @click="commands.italic"
                >
                  <v-icon>fa-italic</v-icon>
                </v-btn>

                <v-btn
                  icon
                  class="menubar__button"
                  :class="{ 'is-active': isActive.strike() }"
                  @click="commands.strike"
                >
                  <v-icon>fa-strikethrough</v-icon>
                </v-btn>

                <v-btn
                  icon
                  class="menubar__button"
                  :class="{ 'is-active': isActive.underline() }"
                  @click="commands.underline"
                >
                  <v-icon>fa-underline</v-icon>
                </v-btn>
                <v-btn
                  icon
                  class="menubar__button"
                  :class="{ 'is-active': isActive.bullet_list() }"
                  @click="commands.bullet_list"
                >
                  <v-icon>fa-list-ul</v-icon>
                </v-btn>

                <v-btn
                  icon
                  class="menubar__button"
                  :class="{ 'is-active': isActive.ordered_list() }"
                  @click="commands.ordered_list"
                >
                  <v-icon>fa-list-ol</v-icon>
                </v-btn>

                <v-btn icon class="menubar__button" @click="commands.horizontal_rule">
                  <v-icon>fa-grip-lines</v-icon>
                </v-btn>

                <v-btn icon class="menubar__button" @click="commands.undo">
                  <v-icon>fa-undo</v-icon>
                </v-btn>

                <v-btn icon class="menubar__button" @click="commands.redo">
                  <v-icon>fa-redo</v-icon>
                </v-btn>
              </div>
            </editor-menu-bar>
          </v-toolbar>
          <editor-content class="mt-5 mb-5 ed" :editor="editor" />
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>
<script>
import { Editor, EditorContent, EditorMenuBar } from "tiptap";
import {
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Italic,
  Link,
  Strike,
  Underline,
  History
} from "tiptap-extensions";

export default {
  components: { EditorContent, EditorMenuBar },
  props: {
    data: Object,
    index: Number
  },
  data() {
    return {
      editor: new Editor({
        extensions: [
          new HardBreak(),
          new HorizontalRule(),
          new Heading({ levels: [1, 2, 3, 4, 5] }),
          new BulletList(),
          new OrderedList(),
          new ListItem(),
          new TodoItem(),
          new TodoList(),
          new Bold(),
          new Italic(),
          new Link(),
          new Strike(),
          new Underline(),
          new History()
        ],
        content: "",
        onUpdate: this.update
      })
    };
  },
  mounted() {
    this.editor.setContent(this.data.content ? this.data.content : "");
  },
  methods: {
    update: function(val) {
      this.$emit("change", val.getHTML());
    }
  },
  watch: {
    data: function(block) {
      this.editor.setContent(this.data.content ? this.data.content : "");
    }
  },
  beforeDestroy() {
    this.editor.destroy();
  }
};
</script>

<style lang="scss" scoped>
.ed {
  padding: 20px;
  border: 1px solid white;
}
</style>
